
































































































import { Component, Vue } from "vue-property-decorator";
import Video from "@/components/Video.vue";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Video,
    BIcon,
    BIconBoxArrowRight,
    Header,
    Menu,
    NextPrevBtn,
    Footer,
  },
})
export default class LetterKeys extends Vue {
  protected videoLetterTips = [
    {
      videoSrc: "https://www.youtube.com/embed/zfVqBV3NV0E",
      videoTitle: "10 astuces pour écrire votre lettre de motivation",
      videoRoot: "Chaîne : Claire BAZIN",
    },
    {
      videoSrc: "https://www.youtube.com/embed/Kuquw_MFX3U",
      videoTitle: "Comment structurer votre lettre de motivation\xa0?",
      videoRoot: "Chaîne : digiSchool",
    },
    {
      videoSrc: "https://www.youtube.com/embed/bGNZQtmKuUg ",
      videoTitle: "Les 7 erreurs à éviter dans une lettre de motivation ",
      videoRoot: "Chaîne : QuestionEntretien",
    },
    {
      videoSrc: "https://www.youtube.com/embed/sE72wb2UsM0",
      videoTitle: "Les règles d’or de la lettre de motivation ",
      videoRoot: "Chaîne :  1er emploi, jobs, stages",
    },
  ];
  protected nxtprevLetterTips = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail4.png",
    NextImage: "/thumbnail3.png",
    PrevLink: "/Lettre_de_Motivation/Fondamentaux",
    NextLink: "/Lettre_de_Motivation/Analyse",
  };
}
